import createModule from "../createModule"
import view from "./view"
import { Creators } from "model/hookUpdater"
import { getRole } from "helpers/permissions/roles"
import { getIsOpPro } from "modules/account-root/selectors"
import { getAccountTokens, getResourceTokens, getResourceId, getResourceType, getResourcePermissionLevel, getTabs } from "./selectors"
import withUrlParams from "hocs/withUrlParams"

import "./styles.scss"

export default withUrlParams(createModule({
  view,
  externalProps: (state, props) => ({
    account: state.global.selected.account,
    userId: props.params.userId,
    resourceAlias: props.params.resourceAlias,
    resourceType: getResourceType(state, props),
  }),
  required: ["account", "resourceAlias", "resourceType"],
  data: [{
    resource: "resourceTokens",
    passthrough: true,
    url: ({ resourceAlias, resourceType }) => ({
      id: `resource-tokens-${resourceType}-${resourceAlias}`,
      query: `query($resourceAlias:IdOrShortIdOrAlias!, $resourceType:ResourceType!){
          resource(id:$resourceAlias, type:$resourceType){
            id
            name
            alias
            type
            permissionLevel
            tokens {
              id
              name
              permissionLevel
              createdAt
              updatedAt
            }
          }
        }`,
      variables: {
        resourceAlias,
        resourceType,
      },
    }),
  },
  {
    resource: "accountTokens",
    passthrough: true,
    url: ({ account }) => {
      return {
        id: `account-tokens-${account}`,
        query: `query{
            tokens{
              id
              name
              createdAt
            }
        }`,
      }
    },
  }],
  mapStateToProps: (state, props) => ({
    role: getRole(state, props),
    resourceId: getResourceId(state, props),
    permissionLevel: getResourcePermissionLevel(state, props),
    accountTokens: getAccountTokens(state, props),
    resourceTokens: getResourceTokens(state, props),
    isOpPro: getIsOpPro(state, props),
    tabs: getTabs(state, props),
  }),
  actions: {
    ...Creators,
  },
}))
